import { TableStatus } from '../types';

export const getTableStatusKey = (status: TableStatus): string => {
  return getTableStatusName(status).toLowerCase();
};

export const getValidTableStatuses = (): TableStatus[] => {
  return [TableStatus.Available, TableStatus.Occupied, TableStatus.Reserved];
};

export const getTableStatusName = (status: TableStatus): string => {
  switch (status) {
    case TableStatus.Available:
      return 'available';
    case TableStatus.Occupied:
      return 'occupied';
    case TableStatus.Reserved:
      return 'reserved';
    default:
      return 'unknown';
  }
};

export const getTableStatusFromString = (status: string): TableStatus => {
  return TableStatus[status as keyof typeof TableStatus];
};
